/** Bordered card frame holding a profile or settings section while it loads. */

import { createThemedStyles } from '@repo/theme/styles';
import { spacings } from 'component/constants';
import type React from 'react';
import { View } from 'react-native';

export function PanelSkeleton({ children }: { children: React.ReactNode }) {
    const s = usePanelSkeletonStyles();
    return <View style={s.panel}>{children}</View>;
}

const usePanelSkeletonStyles = createThemedStyles((tokens) => ({
    panel: {
        borderWidth: 1,
        borderColor: tokens.colors.colorBorderPrimary,
        borderRadius: spacings.sm,
        padding: spacings.xl2,
        backgroundColor: tokens.colors.colorSurfacePrimary,
    },
}));
